import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Spinner } from "@/components/common/Bits";
import { Send, HeartHandshake, Handshake, Newspaper, FolderKanban, MessageSquare } from "lucide-react";

const cards = [
  { label: "Yeni Üyelik Başvurusu", key: "membership_new", total: "membership_total", icon: Send, color: "#1F8A5B" },
  { label: "Yeni Gönüllü Başvurusu", key: "volunteer_new", total: "volunteer_total", icon: HeartHandshake, color: "#0F5132" },
  { label: "Yeni İş Birliği Başvurusu", key: "partnership_new", total: "partnership_total", icon: Handshake, color: "#D6A84F" },
  { label: "Yeni İletişim Mesajı", key: "contact_new", total: "contact_total", icon: MessageSquare, color: "#4B5563" },
  { label: "Devam Eden Projeler", key: "projects_ongoing", total: "projects_published", icon: FolderKanban, color: "#1F8A5B" },
  { label: "Yayındaki Haberler", key: "news_published", total: "news_published", icon: Newspaper, color: "#102A43" },
];

export default function AdminDashboard() {
  const [stats, setStats] = useState(null);
  useEffect(() => { api.get("/dashboard/stats").then(r => setStats(r.data)).catch(()=>setStats({})); }, []);
  if (!stats) return <div className="py-16 text-center"><Spinner/></div>;

  return (
    <div data-testid="admin-dashboard">
      <div className="mb-8">
        <h1 className="font-heading text-3xl font-bold text-[#102A43]">Genel Bakış</h1>
        <p className="text-sm text-[#4B5563] mt-1">USEKO yönetim paneli</p>
      </div>

      <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-5">
        {cards.map((c) => {
          const Icon = c.icon;
          return (
            <div key={c.key} className="p-6 bg-white rounded-2xl border border-[#E5E7EB]" data-testid={`stat-${c.key}`}>
              <div className="flex items-start justify-between">
                <div>
                  <div className="text-sm text-[#4B5563]">{c.label}</div>
                  <div className="mt-2 font-heading text-3xl font-bold text-[#102A43]">{stats[c.key] || 0}</div>
                  {stats[c.total] !== undefined && stats[c.total] !== stats[c.key] && (
                    <div className="mt-1 text-xs text-[#4B5563]">Toplam: {stats[c.total]}</div>
                  )}
                </div>
                <div className="w-10 h-10 rounded-xl flex items-center justify-center" style={{ background: `${c.color}15` }}>
                  <Icon className="w-5 h-5" style={{ color: c.color }}/>
                </div>
              </div>
            </div>
          );
        })}
      </div>

      <div className="mt-10 bg-white rounded-2xl border border-[#E5E7EB] p-6">
        <h2 className="font-heading text-lg font-bold text-[#102A43] mb-4">Son İletişim Mesajları</h2>
        {(stats.recent_contact || []).length === 0 ? (
          <p className="text-sm text-[#4B5563]">Henüz mesaj yok.</p>
        ) : (
          <div className="divide-y divide-[#E5E7EB]">
            {(stats.recent_contact || []).map((m) => (
              <div key={m.id} className="py-3 flex items-center justify-between text-sm">
                <div>
                  <div className="font-medium text-[#102A43]">{m.name}</div>
                  <div className="text-[#4B5563] text-xs">{m.email} · {m.subject}</div>
                </div>
                <div className="text-xs text-[#4B5563]">{new Date(m.created_at).toLocaleDateString("tr-TR")}</div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
